module.exports = __webpack_public_path__ + "static/img/21.4f8e982.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/21.png
// module id = p12p
// module chunks = 0